export interface IProviderActionActionModel {
  actionKey?: string;
  requestData?: any;
  responseData?: any;
}
